import { useEffect } from 'react';

const usePageTitle = (title) => {
	useEffect(() => {
	   document.title = "Improve Your House | " + title
	}, [ title])
}

export default usePageTitle